const DISH_DRAWER_TYPES = {
  MAIN_INGREDIENTS: 'MAIN_INGREDIENTS',
  CHOICE_INGREDIENTS: 'CHOICE_INGREDIENTS',
  DISH_DETAILS: 'DISH_DETAILS',
}

export default DISH_DRAWER_TYPES
